import PaymentDataCard from "./PaymentDataCard";

export default PaymentDataCard;
